import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CARE_FEATURES } from '@/lib/careDirectory';
import BrandLogo from '@/components/brand/BrandLogo';
import './care-page.css';

export default function CareFeatureNav({ current, showBrand = true }) {
  const location = useLocation();
  const active = current || location.pathname;

  return (
    <div className="care-feature-wrap">
      {showBrand ? (
        <div className="care-page-brand">
          <BrandLogo size="md" />
        </div>
      ) : null}
      <nav className="care-feature-nav" aria-label="Care tools">
        {CARE_FEATURES.map((item) => {
          const on = active === item.to || active.startsWith(`${item.to}/`);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={
                on
                  ? 'inline-flex items-center rounded-full px-4 py-2.5 bg-[#0f3e17] text-[#fffefc] no-underline'
                  : 'inline-flex items-center rounded-full px-4 py-2.5 border border-[#E8ECF2] bg-[#fffefc] text-[#0f3e17] no-underline hover:bg-[#f3f6f1]'
              }
            >
              {item.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
